import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AuthContext";
import AuctionCard from "../components/AuctionCard";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

export default function Browse() {
  const { t } = useLanguage();
  const { slug } = useParams();
  const [params, setParams] = useSearchParams();
  const category = slug || params.get("category") || "";
  const sort = params.get("sort") || "ending";
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/categories`).then(r => setCats(r.data));
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams();
    if (category) q.set("category", category);
    q.set("sort", sort);
    q.set("limit", "48");
    axios.get(`${API}/auctions?${q}`).then(r => setItems(r.data)).finally(() => setLoading(false));
  }, [category, sort]);

  const catName = category ? cats.find(c => c.slug === category)?.name : "";
  const pageTitle = catName ? `Aste ${catName} Online` : "Tutte le Aste Online Curate";
  const pageDesc = catName
    ? `Aste online di ${catName.toLowerCase()} su Rarium. Lotti curati e autenticati da esperti indipendenti, spedizione assicurata e pagamenti protetti. Registrazione gratuita.`
    : "Tutte le aste live su Rarium: aste di orologi vintage, arte, gioielli, auto classiche, vini, monete e libri rari. Curate e autenticate dai nostri esperti.";

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <Seo title={pageTitle} description={pageDesc} path={category ? `/category/${category}` : "/browse"} />
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
        <div>
          <div className="overline text-stone-500">{t("Aste Live")}</div>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-2">
            {catName || t("Tutte le aste")}
          </h1>
        </div>
        <div className="flex flex-wrap gap-2 items-center">
          <select
            data-testid="filter-category"
            value={category}
            onChange={(e) => {
              const v = e.target.value;
              const p = new URLSearchParams(params);
              if (v) p.set("category", v); else p.delete("category");
              setParams(p);
              if (v) window.location.href = `/category/${v}`;
              else window.location.href = `/browse`;
            }}
            className="border border-stone-300 bg-white px-3 py-2 text-sm"
          >
            <option value="">{t("Tutte le categorie")}</option>
            {cats.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </select>
          <select
            data-testid="filter-sort"
            value={sort}
            onChange={(e) => {
              const p = new URLSearchParams(params);
              p.set("sort", e.target.value);
              setParams(p);
            }}
            className="border border-stone-300 bg-white px-3 py-2 text-sm"
          >
            <option value="ending">{t("Termina prima")}</option>
            <option value="newest">{t("Più recenti")}</option>
            <option value="price_desc">{t("Prezzo: alto→basso")}</option>
            <option value="price_asc">{t("Prezzo: basso→alto")}</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="text-stone-500">{t("Caricamento…")}</div>
      ) : items.length === 0 ? (
        <div className="text-stone-500 border-t border-stone-200 pt-12 text-center font-serif text-2xl">{t("Nessun lotto disponibile per questa categoria.")}</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-14">
          {items.map((a, i) => <AuctionCard key={a.id} auction={a} index={i} />)}
        </div>
      )}
    </div>
  );
}
